import BaseFormPresenter from "../../../base/BaseFormPresenter";

class SurveyFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async getRecruiter() {
    const collection = "users";
    const id = this.view.getRecruiterId();
    if (id) {
      const params = { include: ["all"] };
      try {
        this.view.showProgress();
        const object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        console.log("Result of getObjectUseCase.execute:", object);
        this.view.hideProgress();
        return object;
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
        return null;
      }
    }
    return null;
  }

  async submit() {
    const recruiterId = this.view.getRecruiterId();
    const recruiter = await this.getRecruiter();
    if (!recruiter) {
      console.warn("Recruiter not found.");
      return;
    }
    const recruiterName = `${recruiter?.employee.firstName} ${recruiter.employee?.middleName} ${recruiter.employee?.lastName}`;
    this.change.recruiter = { id: recruiterId };
    this.change.recruiterName = recruiterName;
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      await this.save();
      this.view.navigateTo("/survey-form/2557864545324234");
      //   this.view.submissionSuccess();
      //   this.view.showSuccessSnackbar("Successfully saved!");
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default SurveyFormPresenter;
